var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m--t-2"},[_c('h2',{staticClass:"h2"},[_vm._v("Položky ve filtru")]),_c('catalogue-filter-offer'),_c('catalogue-filter-selected')],1)}
var staticRenderFns = []

export { render, staticRenderFns }